/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */
import React from "react";
import { IconLinkTabContent } from "./tab-content";

const IconLinkTabItems = (props) => {

    const tabs = props?.tabs;
    const hasTabs = Array.isArray(tabs) && tabs.length > 0;

    return (
        <div className="tab-items">
            {hasTabs && tabs.map((tab, index) => {
                return <IconLinkTabContent tab={tab} key={index} />;
            }
            )}
        </div>
    );
};

IconLinkTabItems.displayName = "IconLinkTabItems";
export { IconLinkTabItems };
